'use strict';

angular.module('users').controller('SettingsController', ['$scope', '$http', '$location', 'Users', 'Authentication', 'Utilities',
	function ($scope, $http, $location, Users, Authentication, Utilities) {
		$scope.user = Authentication.user;
    $scope.emailVerifyButton = {
      text :'Resend Verification Code',
      sentOnce : false
		} ;
		$scope.accountDeleteButton = {
			text: 'Request Account Deletion',
			sentOnce: false,
			processing: false
		};
		// If user is not signed in then redirect back home
		if (!$scope.user) $location.path('/');

		// Check if there are additional accounts
		$scope.hasConnectedAdditionalSocialAccounts = function(provider) {
			for (var i in $scope.user.additionalProvidersData) {
				return true;
			}

			return false;
		};

    $scope.resendEmailVerification = function(){
      $http.get('/users/resend-email-verification').then(function(response){
        $scope.emailVerifyButton.text ='Verification Code Sent';
        $scope.emailVerifyButton.sentOnce = true;
      }).catch(function(response){
      });

    };

		// Check if provider is already in use with current user
		$scope.isConnectedSocialAccount = function(provider) {
			return $scope.user.provider === provider || ($scope.user.additionalProvidersData && $scope.user.additionalProvidersData[provider]);
		};

		// Remove a user social account
		$scope.removeUserSocialAccount = function(provider) {
			$scope.success = $scope.error = null;

			$http.delete('/users/accounts', {
				params: {
					provider: provider
				}
			}).then(function(response) {
				// If successful show success message and clear form
				$scope.success = true;
				$scope.user = Authentication.user = response.data;
			}).catch(function(response) {
				$scope.error = response.data.message;
			});
		};

		// Send account delete request email to user and us
		$scope.requestAccountDeletion = function() {

			var user = new Users($scope.user);
			$scope.accountDeleteButton.processing = true;

			user.$delete(function (response) {
				$scope.accountDeleteButton.processing = false;
				$scope.accountDeleteButton.sentOnce = true;

				Utilities.showMessage('Delete Account', 'Your delete request got sent. You will receive an additional email to confirm that.');

				$scope.accountDeleteButton.text = 'Deletion Requested';
			}, function (errorReponse) {
				$scope.accountDeleteButton.processing = false;

				Utilities.showMessageErrorResponse(errorReponse);
			});

		};

		// Update a user profile
		$scope.updateUserProfile = function(isValid) {
			if (isValid) {
				$scope.success = $scope.error = null;
				var user = new Users($scope.user);

				user.$update(function(response) {
					$scope.success = true;
					Authentication.user = response;
				}, function(response) {
					$scope.error = response.data.message;
				});
			} else {
				$scope.submitted = true;
			}
		};

		// Change user password
		$scope.changeUserPassword = function() {
			$scope.success = $scope.error = null;

			$http.post('/users/password', $scope.passwordDetails).then(function(response) {
				// If successful show success message and clear form
				$scope.success = true;
				$scope.passwordDetails = null;
			}).catch(function(response) {
				$scope.error = response.data.message;
			});
		};
	}
]);